import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export async function listClientNetworkLogos() {
    const res = await apiFetch(`${API_BASE}/networks/client/logos`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити логотипи");
    }
    return await res.json();
}

export function clientNetworkLogoUrl(fileUrl) {
    if (!fileUrl) return "";
    return `${API_BASE}/networks/client/logo/download/${encodeURIComponent(fileUrl)}`;
}

export async function fetchClientNetworkLogoBlob(fileUrl) {
    const res = await apiFetch(clientNetworkLogoUrl(fileUrl));
    if (!res.ok) throw new Error("Не вдалося завантажити логотип");
    return await res.blob();
}
